import { contentfulToImageData, formatRichText, getBGfromVariant } from "../../functions";

export const DoctorImage = ({ title, image, imageSignature, imageFooter, footerBackgroundColor, siteStatus }) => {
	const imageData = contentfulToImageData(image);
	if (!imageData) {
		console.warn("Doctor image will not appear as there is no image data");
		return null;
	}
	const overlayRichText = formatRichText(imageSignature, siteStatus);
	const footerRichText = imageFooter ? formatRichText(imageFooter, siteStatus) : null;
	const bgColor = getBGfromVariant(footerBackgroundColor);

	return (
		<>
			<div className="relative w-full ">
				<img
					src={imageData.imageUrl}
					alt={imageData.alt || title || "Doctor Image"}
					className={`object-cover w-full h-full object-top block  rounded-[50px]`}
				/>
				<div className="absolute left-0 bottom-10 p-2 text-left text-black w-1/2 bg-is2-blue/70 z-4  [&>p]:text-white rounded-sm">
					{overlayRichText}
				</div>
			</div>

			{footerRichText && (
				<div className={`${bgColor} rounded-b-[50px] p-6 text-center relative -mt-9`}>{footerRichText}</div>
			)}
		</>
	);
};

// const DoctorImageFooter = ({ quoteData }) => {
//   if (!quoteData?.content.length) {
//     console.warn("Doctor quote will not appear as there is no quote data");
//     return null;
//   }
//   return (
//     <div className="bg-is2-blue-50 rounded-b-[50px] p-6 text-center relative -mt-9">
//       {quoteData?.data[0] && (
//         <div className="flex justify-center items-center space-x-2 mb-4">
//           <img src={quoteData.data[0]} alt="quote" className="w-6 h-6" />
//           <img
//             src={quoteData.data[0]}
//             alt="quote"
//             className="w-6 h-6 rotate-180"
//           />
//         </div>
//       )}

//       <p className="text-is2-gray-300">{quoteData?.content[0] || ""}</p>
//       <h4 className="font-bold text-[#313334] text-xl mt-2">
//         {quoteData?.content[1] || ""}
//       </h4>
//     </div>
//   );
// };
